export default __webpack_public_path__ + "static/media/Apollo_Desktop.d2de15f9.mp4";